import { Injectable } from '@angular/core';

import { ModalDialogService } from '../../_shared/services/modal-dialog.service';
import { UtilService } from '../../_shared/services/util.service';

import { Category } from './category.model';
import { CategoriesModalComponent } from '../components/categories-modal/categories-modal.component';
import { CategoryModalComponent } from '../components/category-modal/category-modal.component';
import { CategoryTranslationModalComponent } from '../components/category-translation-modal/category-translation-modal.component';

@Injectable({
  providedIn: 'root',
})
export class CategoryModalService {
  constructor(private modalDialogService: ModalDialogService, private utilService: UtilService) {}

  openCategoriesModal(successCallback) {
    const options = {
      width: '700px', // 1000px
      minHeight: '80vh',
      maxHeight: '80vh',
      position: { top: '5vh' },
      disableClose: true,
      data: {
        title: 'CATEGORIES',
      },
      confirmCallback: successCallback,
      // preventCloseOnSave: true,
    };

    this.modalDialogService.open(options, CategoriesModalComponent);
  }

  openCategoryModal(
    category: Category,
    defaultLanguage,
    additionalLanguages,
    mode,
    successCallback = null
  ) {
    const confirmCallback = (result) => {
      // Edit
      if (category.id) {
        category.name = result.name;
        category.description = result.description;
        category.type = result.type;

        return this.utilService.changeItemRowStyle(category.id);
      }

      return successCallback(result);
    };

    const options = {
      disableClose: true,
      data: {
        title: 'CATEGORY_DETAILS',
        obj: category,
        params: {
          defaultLanguage: defaultLanguage,
          additionalLanguages: additionalLanguages,
          mode: mode,
        },
      },
      confirmCallback: confirmCallback,
    };

    this.modalDialogService.open(options, CategoryModalComponent);
  }

  openCategoryTranslation(category: Category, language: any) {
    const options = {
      panelClass: 'dialog-sidepanel',
      position: { right: '0' },
      data: {
        title: 'CATEGORY_DETAILS',
        obj: category,
        params: {
          language: language,
        },
      },
    };

    this.modalDialogService.open(options, CategoryTranslationModalComponent);
  }
}
